<template>
    <div class="row">
        <div class="col-xl-3 col-lg-4 col-12 mb-xl-0 mb-4">
            <nav class="navbar navbar-vertical fixed-start navbar-expand-sm navbar-light"
                 style="position: relative; border-width: 0; max-width: 100%">
                <div class="collapse navbar-collapse show">
                    <ul class="navbar-nav mb-md-3">
                        <li class="nav-item">
                            <a
                                href="#"
                                class="nav-link"
                                v-for="(tabItem, id) in tabs"
                                :key="id"
                                :class="{active:tab === tabItem.value, disabled : !tabItem.isActive}"
                                @click.prevent="tab = tabItem.value"
                            >
                                <img
                                    v-if="tabItem.img"
                                    :src="require('@/assets/img/icons/social/' + tabItem.img)"
                                    alt=""
                                    class="mr-3"
                                    :class="{ inactive_icon:  !tabItem.isActive || tab !== tabItem.value}"
                                    height="22"
                                    width="22"
                                />
                                <i class="mx-1 fe" :class="{[tabItem.icon]: tabItem.icon}" v-if="tabItem.icon"></i>
                                {{ $t(tabItem.label) }}
                                <template v-if="!tabItem.isActive">&nbsp; ({{ $t('Soon') }})</template>
                            </a>
                        </li>
                    </ul>
                </div>

            </nav>
        </div>
        <div class="col-xl-9 col-lg-8 col-12">
            <div v-if="tab === 'TELEGRAM'">
                <form class="">
                    <TelegramAuth/>
                </form>
            </div>
            <div v-if="tab === 'ONLINE_PBX'">
                <OnlinePBXIntegrationComponent />
            </div>
            <div v-if="tab === 'GOOGLE_DRIVE'">
                <div class="row mb-1">
                    <div class="col-12">
                        <label>{{ $t('Google Drive') }}</label>
                        <small class="form-text text-muted">{{ $t('Google Drive Description') }}</small>
                    </div>
                </div>
            </div>
            <div v-if="tab === 'WHATSAPP'">
                <div class="row mb-1">
                    <div class="col-12">
                        <label>{{ $t('Whatsapp') }}</label>
                        <small class="form-text text-muted">{{ $t('Whatsapp Description') }}</small>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ButtonLoading from '@/components/ButtonLoading'
import TelegramAuth from "./Integrations/TelegramAuth";
import OnlinePBXIntegrationComponent from "./Integrations/OnlinePBXIntegrationComponent.vue";

export default {
    components: {
        TelegramAuth,
        OnlinePBXIntegrationComponent,
        ButtonLoading
    },
    watch: {
    },
    data() {
        return {
            model: {},
            telegram: {},
            tab: 'TELEGRAM',
            tabs: [
                {
                    value: 'TELEGRAM',
                    label: 'Telegram',
                    icon: 'fe-send',
                    //img: 'brand-telegram.svg',
                    isActive: true
                },
                {
                    value: 'ONLINE_PBX',
                    label: 'OnlinePBX',
                    icon: 'fe-phone',
                    isActive: true
                },
                /*{
                  value: 'GOOGLE_DRIVE',
                  label: 'Google Drive',
                  img: 'brand-google-drive.svg',
                  isActive: true
                },
                {
                  value: 'WHATSAPP',
                  label: 'Whatsapp',
                  img: 'brand-whatsapp.svg',
                  isActive: true
                }*/
            ]
        };
    },
    created() {}
}
</script>

<style lang="scss">
.inactive_icon {
    filter: invert(53%) sepia(6%) saturate(1772%) hue-rotate(177deg) brightness(95%) contrast(87%);
}
</style>
